import {
	MimaButton,
	MimaText,
	Modal,
} from '../../components';
import { vendorStore } from '../../stores';
import React from 'react';

const DeleteVendor = ({ closeModal, goBack, onDelete, loading }) => {

  const { selectedVendor } = vendorStore

	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			<MimaText variant="subtitleBold" align="center" mb={3}>
				Delete Vendor
			</MimaText>

      <MimaText mb={2}>
        Are you sure you want to delete <span style={{ fontWeight: '700', color: 'var(--color-primary)' }}>{selectedVendor.name}?</span>
      </MimaText>

      <div className='modal__beside'>
        <MimaButton
          title={'Yes'}
          width={18}
          onClick={() => onDelete(selectedVendor._id)}
          loading={loading}
        />

        <MimaButton
          title={'Cancel'}
          width={18}
          buttonColor={'grey'}
          onClick={() => closeModal()}
        />
      </div>
		</Modal>
	);
};

export default DeleteVendor;